import parseSubviewModel from "~/navigation/parseSubviewModel";

export default function isPathValid(path, availableModels) {
    for(let i = 0; i < path.length; i++) {
        let modelName = parseSubviewModel(path[i].modelName);
        
        if(availableModels.indexOf(modelName) < 0) {
            return false;
        }
    }
    
    return true;
}